import { CommonModule } from '@angular/common';
import {
  afterNextRender,
  Component,
  ElementRef,
  inject,
  OnInit,
  signal,
  viewChild,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { injectNavigationEnd } from 'ngxtension/navigation-end';
import { AdminStore } from '../../stores/admin.store';
import { IMenu, LayoutStore } from '../../stores/layout.store';
import { SideMenuModule } from './side-menu/side-menu.module';
import { TopBar } from './top-bar/top-bar.component';

export const menus: IMenu[] = [
  {
    icon: 'icon-[mdi--home]',
    name: '대시보드',
    href: '/dashboard',
  },
  // {
  //   icon: 'icon-[mdi--account]',
  //   name: '회원 관리',
  //   href: '/user',
  // },
  {
    icon: 'icon-[mdi--shield-account]',
    name: '관리자 관리',
    href: '/admin',
  },
  // {
  //   icon: 'icon-[mdi--calendar-star]',
  //   name: '행사 관리',
  //   href: '/event',
  // },
  // {
  //   icon: 'icon-[mdi--storefront-outline]',
  //   name: '쇼핑몰 관리',
  //   href: '/shop/dashboard',
  //   showChevron: true,
  // },
  {
    icon: 'icon-[mdi--cog]',
    name: '사이트 관리',
    children: [
      // {
      //   name: '배너 관리',
      //   href: '/site/banner',
      // },
      {
        name: '약관 관리',
        href: '/site/terms',
      },
      {
        name: '팝업 관리',
        href: '/site/popup',
      },
      {
        name: '띠배너 관리',
        href: '/site/bottom-banner',
      },
      {
        name: '표시 문구 관리',
        href: '/site/menu-text',
      },
      {
        name: 'FAQ 관리',
        href: '/customer/faq',
      },
      // {
      //   name: '연혁 관리',
      //   href: '/site/history',
      // },
      // {
      //   name: '파트너 관리',
      //   href: '/site/partner',
      // },
      // {
      //   name: '인증서/특허 관리',
      //   href: '/site/certificate',
      // },
      {
        name: '사업자정보 관리',
        href: '/site/business-info',
      },
    ],
  },
  {
    icon: 'icon-[ri--customer-service-2-fill]',
    name: '문의 관리',
    href: '/customer/inquiry',
  },
  {
    icon: 'icon-[mdi--domain]',
    name: '업체 관리',
    href: '/site/branch',
  },
  {
    icon: 'icon-[mdi--clipboard-text-outline]',
    name: '콘텐츠 관리',
    href: '/site/preorder',
  },
  {
    icon: 'icon-[mdi--gift-outline]',
    name: '프로모션 관리',
    href: '/site/promotion',
  },
  // {
  //   icon: 'icon-[mdi--floor-plan]',
  //   name: '배치도 관리',
  //   href: '/floor-plan',
  // },
  // {
  //   icon: 'icon-[mdi--post]',
  //   name: '게시글 관리',
  //   href: '/post',
  // },
  // {
  //   icon: 'icon-[mdi--search-web]',
  //   name: 'SEO / AEO 관리',
  //   href: '/site/seo-management',
  // },
  // {
  //   icon: 'icon-[mdi--qrcode]',
  //   name: 'QR코드 관리',
  //   href: '/qr-code',
  // },
  // {
  //   icon: 'icon-[mdi--bell]',
  //   name: '알림 발송 이력 관리',
  //   href: '/notification-batch',
  // },
  // {
  //   icon: 'icon-[mdi--account-circle]',
  //   name: '마이페이지',
  //   href: '/my-page',
  // },
  // {
  //   icon: 'icon-[material-symbols--bar-chart]',
  //   name: '통계',
  //   href: '/statistics',
  // },
];

@Component({
  host: {
    ngSkipHydration: 'true',
  },
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  standalone: true,
  imports: [RouterModule, CommonModule, TopBar, SideMenuModule],
})
export class LayoutComponent implements OnInit {
  readonly store = inject(LayoutStore);
  readonly adminStore = inject(AdminStore);
  readonly router = inject(Router);

  readonly topBar = viewChild<ElementRef<HTMLDivElement>>('topBar');
  readonly navigationEnd$ = injectNavigationEnd();
  readonly topBarHeight = signal<number>(0);
  readonly container = viewChild<ElementRef<HTMLDivElement>>('container');

  currentMenu = this.store.currentMenu;
  currentChildMenu = this.store.currentChildMenu;
  path = this.store.path;
  menus = this.store.menus;
  user = this.adminStore.admin;

  constructor() {
    afterNextRender(() => {
      const topbar = this.topBar()?.nativeElement;

      if (topbar) {
        this.topBarHeight.set(topbar.clientHeight);
      }

      const container = this.container()?.nativeElement;

      if (container) {
        this.router.events.subscribe({
          next: () => {
            container.scrollTo({ top: 0, behavior: 'smooth' });
          },
        });
      }
    });
  }

  ngOnInit() {
    this.store.setMenus(menus);
    this.store.setPath(this.router.url);

    this.navigationEnd$.subscribe({
      next: () => {
        this.store.setPath(this.router.url);
      },
    });
  }

  navigate(menu: IMenu) {
    this.router.navigateByUrl(menu.href ?? '');
  }
}
